export default __webpack_public_path__ + "static/media/page-note.a7653e42.svg";